<template>
  <div>
    <div class="Top3QaRecommend">
      <el-avatar class="chat-avatar" :src="chatHead"></el-avatar>
      <div class="Top3QaRecommend-content">
        <p v-html="title"></p>
        <ul class="button_list">
          <li v-for="(item, index) in top3Qa" :key="index" @click="askQuestion(item)">
            <span>{{item}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="clear-float"></div>
  </div>
</template>

<script>
import { getMessageList } from '@/utils/index'

export default {
  name: 'Top3QaRecommend',
  props: {
    title: String, // 标题
  },
  data(){
    return {
      top3Qa: [], // top3 问题
      chatHead: '/static/images/chat-head.png',
    }
  },
  mounted() {
    this.top3Qa = [
      '怎么获取试纸？',
      '积分为什么无法兑换试纸？',
      '血糖仪/试纸/针头物流信息',
    ]
  },
  methods: {
    async askQuestion(item) {
      const that = this
      getMessageList(item, that)
    }
  },
}
</script>

<style scoped>
.Top3QaRecommend {
  position: relative;
  float: left;
  width: 85%;
  text-align: left;
  padding-left: 40px;
  margin-bottom: 25px;
}
.Top3QaRecommend-content {
  line-height: 27px;
  margin-top: 10px;
  border: 1px solid #efefef;
  padding: 0 10px;
  border-top-right-radius: 25px;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.09);
  padding-bottom: 10px;
}
.Top3QaRecommend-content p {
  margin-bottom: 0px;
}
.button_list {
  text-align: center;
  list-style: none;
  padding-left: 0px;
  margin: 5px 0;
}
.button_list li {
  display: inline-block;
  line-height: 30px;
  color: #D72618;
  border: solid 2px #D72618;
  border-radius: 7px;
  text-align: center;
  margin: 7px 0;
  width: 80%;
}
</style>
